/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class VehicleMapCheckShowVehicleController {

        public static $inject:string[] = [
            'CurrentUser',
            '$dealerwareNotification',
            'vehicle'
        ];

        constructor(public CurrentUser: any,
                    public $dealerwareNotification: any,
                    public vehicle: any) {}

        private isCarConnected() : boolean {
            return this.vehicle.vehicleDetails.data.connected;
        }

        private rented() : boolean {
            return this.vehicle.vehicleDetails.data.current_state === 'rented';
        }

        public shouldShowVehicleMarker () : boolean {
            return this.canViewVehiclePosition() && this.isCarConnected();
        }

        public canViewVehiclePosition() : boolean {
            return this.vehicle.vehicleDetails.data.position_viewable;
        }

        public error () : void {
            var message: string;

            if (!this.isCarConnected()) {
                message = 'This vehicle does not have a connected car device.'
            } else if (this.rented()) {
                message = 'Position not available for vehicles out on contract.'
            } else {
                message = 'Position not available for this vehicle.'
            }
            this.$dealerwareNotification.error(message);
        }
    }

    getDealerwareWebComponentsModule().controller(
        'VehicleMapCheckShowVehicleController', VehicleMapCheckShowVehicleController
    );


    export class VehicleMapDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$timeout',
            '$controller'
        ];

        public vehicle: any;

        public mapCenter: any;
        public mapConfig: any;
        public mapZoom: any;
        public markers: any;
        public loading: boolean;

        public vehicleMapCheckShowVehicleController: any;

        constructor (
            public $scope: any,
            public $timeout: any,
            public $controller: any
        ) {
            var _that = this;

            if (! this.mapConfig) {
                this.createMapConfig();
            }

            // Make sure to only use the google API to create the map if the vehicle
            // (coordinates) have loaded (loadVehicleDetails), or after that, switching
            // back to the Map tab from another (showMap property).
            //
            this.$scope.$watch(
                ( ) => {
                    return _that.vehicle;
                },
                (vehicle: any) => {
                    if (vehicle !== undefined && vehicle.showMap) {
                        _that.vehicleMapCheckShowVehicleController.vehicle = vehicle;
                        _that.initMap();
                    }
                }, true
            );

            this.vehicleMapCheckShowVehicleController = this.$controller(
                'VehicleMapCheckShowVehicleController', { vehicle: this.vehicle }
            );
        }

        private initMap () : void {

            // We shouldn't even be running initMap from VehicleDetailsController if the car position
            // and/or current_state is bad, but leave this check in just in case the logic changes to
            // always allow navigating to this screen, good vehicle or not.
            //
            if (! this.vehicleMapCheckShowVehicleController.shouldShowVehicleMarker()) {
                this.vehicleMapCheckShowVehicleController.error();
                return;
            }

            this.loading = true;
            this.showVehicleMarker();
            this.vehicle.showMap = false;
        }

        private showVehicleMarker() : void {

            var _that = this;

            // The map directive seems to be overriding my mapZoom set on the constructor,
            // so this hackish thing seems to be necessary.
            //
            this.$timeout( ( ) => {
                _that.mapZoom = 15;
                _that.mapCenter = {
                    lat: _that.vehicle.vehicleDetails.data.latitude,
                    lng: _that.vehicle.vehicleDetails.data.longitude
                };
            }, 1000);

            this.markers = [ { data: this.vehicle.vehicleDetails.data } ];

            this.loading = false;
        }

        private createMapConfig () {

            this.mapConfig = {
                infoWindowTemplate: '/components/vehicle/map/vehicle_map_info_window_template.html',
                markerKey: 'current_state',
                scrollToZoom: true,
                markerColors: {
                    disposed: '999999',             // grey
                    hard_hold: 'ffa31a',            // orange
                    in_prep: 'b3c6ff',              // light blue
                    maintenance: 'ff0000',          // red
                    rented: '66c0e0',               // light blue
                    returned: '3333cc',             // blue
                    shuttle: 'ffb3ff',              // pink
                    staged: '009900',               // green
                    totaled_pending_ins: 'ffff00'   // yellow
                }
            };
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleMapDirectiveController', VehicleMapDirectiveController);

    export class VehicleMapDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleMapDirectiveController';
        public controllerAs     : string    =   'vehicleMapController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   {
            vehicle: '='
        };
        public templateUrl      : string    =   '/components/vehicle/map/vehicle_map_directive.html';

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => { }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleMap",() => new VehicleMapDirective());
 }
